"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Thiana API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfSitInput = instanceOfSitInput;
exports.SitInputFromJSON = SitInputFromJSON;
exports.SitInputFromJSONTyped = SitInputFromJSONTyped;
exports.SitInputToJSON = SitInputToJSON;
/**
 * Check if a given object implements the SitInput interface.
 */
function instanceOfSitInput(value) {
    if (!('access_level' in value) || value['access_level'] === undefined)
        return false;
    if (!('professional_id' in value) || value['professional_id'] === undefined)
        return false;
    return true;
}
function SitInputFromJSON(json) {
    return SitInputFromJSONTyped(json, false);
}
function SitInputFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'access_level': json['access_level'],
        'professional_id': json['professional_id'],
    };
}
function SitInputToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'access_level': value['access_level'],
        'professional_id': value['professional_id'],
    };
}
